import { RecoverStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { FrontendStepType, PartialWithRequiredType } from "../steps";
import { RecoverConfigPreview } from "./recover-config-preview";

export const recoverStepType: FrontendStepType<
  PartialWithRequiredType<RecoverStep>
> = {
  valid: (state) => !!state.templateId,
  type: "custom",
  customInspector: (props) => <RecoverConfigPreview {...props} />,
};
